import {
  assignIfExists,
  mapResults,
  removeItemByCode,
  mapItemOrderByValues,
} from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import actions from '../constants';
import { auditsResult, findAudit, newAuditList } from './state';

const switchEntityFilter = withDraft((draft, action) => {
  const item = findAudit(draft, action);
  item.filters.entity = action.entity;
  item.currentPage = 1;
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

const updateAuditsFilter = withDraft((draft, action) => {
  const item = findAudit(draft, action);
  item.filters[action.filter] = action.value;
});

const fetchAudits = withDraft((draft, action) => {
  const item = findAudit(draft, action);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.audits[action.category].results.push({
      ...newAuditList(action.code),
      readStatus: states.PENDING,
    });
  }
});

const toggleAuditsColumnOrderBy = withDraft((draft, { category, code, orderByColumn }) => {
  const item = findAudit(draft, { category, code });
  item.readStatus = states.PENDING;
  item.readErrors = [];
  item.orderBy = mapItemOrderByValues(item.orderBy, orderByColumn, item.singleSorting);
});

const toggleAuditsSingleSorting = withDraft((draft, action) => {
  const item = findAudit(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
  item.singleSorting = !item.singleSorting;
  item.orderBy = [item.orderBy[0]];
});

const showAudits = withDraft((draft, action) => {
  const item = findAudit(draft, action);
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = action.append
    ? mapResults(item.results, action, auditsResult) : mapResults([], action, auditsResult);
  item.name = action.name;
  item.pageSize = action.pageSize;
  item.count = action.resultsCount;
  item.currentPage = action.currentPage;
  item.totalPages = action.totalPages;
});

const showAuditsError = withDraft((draft, action) => {
  const item = findAudit(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const closeAudits = withDraft((draft, action) => {
  const item = findAudit(draft, action);
  if (item?.code) {
    draft.audits[action.category].results = removeItemByCode(draft.audits[action.category].results, item);
  } else if (item) {
    assignIfExists(item, newAuditList(null));
  }
});

export default {
  [actions.CLOSE_AUDITS]: closeAudits,
  [actions.FETCH_AUDITS]: fetchAudits,
  [actions.REFRESH_AUDITS]: fetchAudits,
  [actions.SHOW_AUDITS]: showAudits,
  [actions.SHOW_AUDITS_ERROR]: showAuditsError,
  [actions.SWITCH_ENTITY_FILTER]: switchEntityFilter,
  [actions.TOGGLE_AUDITS_COLUMN_ORDER_BY]: toggleAuditsColumnOrderBy,
  [actions.TOGGLE_AUDITS_SINGLE_SORTING]: toggleAuditsSingleSorting,
  [actions.UPDATE_AUDITS_FILTER]: updateAuditsFilter,
};
